<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>
        <section class="dp-right">
            <!-- 工具条 -->
            <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

            <div class="table-wrapper">
                                <el-table :data="tableData" v-loading="listLoading" class="custom-elegant-table"
                    header-row-class-name="elegant-table-header" row-class-name="elegant-table-row" style="width: 100%">

                    <el-table-column prop="SortIndex" label="序号" width="80" align="center"></el-table-column>

                    <el-table-column prop="Image" label="资源预览" align="center" header-align="center" width="120">
                        <template slot-scope="scope">
                            <div v-if="scope.row.Type === 'video' || (scope.row.Image && (scope.row.Image.toLowerCase().endsWith('.mp4') || scope.row.Image.toLowerCase().endsWith('.mov')))"
                                class="table-video-wrapper" @click="handlePreviewRecord(scope.row.Image, 'video')">
                                <video v-if="!isOssListVideo(scope.row.Image)"
                                    :src="resolveMediaUrl(scope.row.Image) + '#t=0.5'" class="table-thumb-preview" muted
                                    preload="metadata"></video>
                                <div v-else class="table-video-oss-placeholder">
                                    <i class="el-icon-video-camera"></i>
                                </div>
                                <div class="table-video-icon">
                                    <i class="el-icon-video-play"></i>
                                </div>
                            </div>
                            <div v-else class="table-image-list">
                                <oss-media-thumbs :media="scope.row.Image" img-class="thumb-img" />
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column prop="DepartmentName" label="所属机构" width="" align="center"></el-table-column>
                    <el-table-column prop="Title" label="标题" width="" align="center"></el-table-column>
                    <el-table-column prop="UpdateTime" label="上传时间" width="" align="center"></el-table-column>

                    <el-table-column label="操作" width="180" align="center">
                        <template slot-scope="scope">
                            <el-link type="primary" :underline="false" class="action-link"
                                @click="handleEdit(scope.row)">编辑</el-link>
                            <el-divider direction="vertical"></el-divider>
                            <el-link type="danger" :underline="false" class="action-link"
                                @click="handleDelete(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>

                </el-table>

                <!-- 分页区域 -->
                <el-col :span="24" class="toolbar">
                    <el-pagination background layout="total, prev, pager, next, jumper" :total="total"
                        :current-page="page" :page-size="pageSize" style="float: right">
                    </el-pagination>
                </el-col>

            </div>

            <!-- 弹出的新增/编辑对话框 -->
            <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px"
                custom-class="elegant-dialog" @closed="onCampusDialogClosed">
                <el-form :model="form" :rules="rules" ref="dataForm" label-width="80px" class="dialog-form">
                    <el-form-item label="标题" prop="Title">
                        <el-input v-model="form.Title" placeholder="请输入标题" class="dialog-input"></el-input>
                    </el-form-item>

                    <el-form-item label="资源类型" prop="Type">
                        <el-radio-group v-model="form.Type" @change="handleTypeChange">
                            <el-radio label="image">图片</el-radio>
                            <el-radio label="video">视频</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <!-- 去除所属机构选择，直接关联页面统一选中的学校 ID -->
                    <el-form-item label="所属机构" v-if="form.Id">
                        <el-input v-model="form.DepartmentName" disabled class="dialog-input"></el-input>
                    </el-form-item>

                    <el-form-item label="排序" prop="SortIndex">
                        <el-input-number v-model="form.SortIndex" :min="0" controls-position="right"
                            style="width: 100%"></el-input-number>
                    </el-form-item>

                    <el-form-item :label="form.Type === 'video' ? '视频' : '图片'" prop="Image">
                        <div class="upload-wrapper">
                            <!-- 图片上传 -->
                            <el-upload v-if="form.Type !== 'video'" class="single-uploader" action="#"
                                :auto-upload="false" :show-file-list="false"
                                :on-change="handleSceneryImageChange"
                                :disabled="!!deferredImageDisplay('sceneryImage', form.Image)">
                                <div v-if="deferredImageDisplay('sceneryImage', form.Image)" class="preview-container" @click.stop="">
                                    <img v-if="deferredImageDisplay('sceneryImage', form.Image)" v-oss-src="deferredImageDisplay('sceneryImage', form.Image)" class="preview-img">
                                    <div class="preview-mask">
                                        <i class="el-icon-zoom-in"
                                            @click.stop="handlePreviewRecord(form.Image, 'image')"></i>
                                        <i class="el-icon-delete" @click.stop="clearSceneryImage"></i>
                                    </div>
                                </div>
                                <i v-else class="el-icon-plus uploader-icon"></i>
                            </el-upload>

                            <!-- 视频上传 -->
                            <el-upload v-else class="upload-demo video-uploader" action="#" :accept="'.mp4,.mov'" :show-file-list="false"
                                :http-request="customCampusVideoUpload" :before-upload="beforeVideoUpload" drag
                                :disabled="!!(form.Image || pendingVideoPreviewUrl)">
                                <i v-if="videoLoading" class="el-icon-loading"
                                    style="font-size: 67px; color: #c0c4cc;"></i>
                                <template v-else>
                                    <div v-if="form.Image || pendingVideoPreviewUrl" class="preview-container" @click.stop="">
                                        <video :src="campusVideoPreviewSrc"
                                            style="width: 100%; height: 160px;"></video>
                                        <div class="preview-mask">
                                            <i class="el-icon-video-play"
                                                @click.stop="handlePreviewRecord(campusVideoPreviewSrc, 'video')"></i>
                                            <i class="el-icon-delete" @click.stop="clearCampusVideoSelection"></i>
                                        </div>
                                    </div>
                                    <i v-else class="el-icon-upload"></i>
                                </template>
                                <div v-if="!(form.Image || pendingVideoPreviewUrl) || videoLoading" class="el-upload__text"
                                    style="line-height: normal;">
                                    <div style="margin-bottom: 5px;">将文件拖到此处，或<em>点击上传</em></div>
                                    <div style="color: #909399; font-size: 13px;">大小不超过100M,mp4/mov文件</div>
                                </div>
                            </el-upload>
                            <div class="upload-tip">{{ form.Type === 'video' ? '支持 mp4、mov 格式' : '支持 jpg、jpeg、png 格式' }}
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" class="save-btn" :loading="submitLoading"
                        @click="submitForm">确认提交</el-button>
                </div>
            </el-dialog>

            <!-- 视频上传进度 -->
            <el-dialog
                title="视频上传中"
                :visible.sync="videoUploading"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                width="400px"
                append-to-body
            >
                <el-progress :percentage="videoUploadProgress" :stroke-width="16"></el-progress>
                <div style="text-align:center;margin-top:12px;color:#909399;font-size:13px;">请勿关闭或切换页面</div>
            </el-dialog>

            <!-- 预览弹窗 -->
            <el-dialog :visible.sync="previewVisible" append-to-body width="800px"
                :title="previewType === 'video' ? '视频预览' : '图片预览'">
                <div style="text-align: center;">
                    <video v-if="previewType === 'video' && previewPlaySrc" :src="previewPlaySrc" controls autoplay
                        style="max-width: 100%; max-height: 500px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15);" />
                    <img v-else-if="previewType === 'image' && previewUrl"
                        v-oss-src="previewUrl"
                        style="max-width: 100%; max-height: 70vh; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); object-fit: contain;">
                </div>
            </el-dialog>


        </section>
    </section>
</template>

<script>
import DepartmentPane from '../../../components/DepartmentPane'
import Toolbar from '../../../components/Toolbar'
import { getButtonList } from '../../../promissionRouter'
import { BaseApiUrl } from '../../../api/base';
import { getCampusSceneryList, saveCampusScenery, removeCampusScenery } from '../../../api/modules/big-screen';
import {
    attachLocalVideoFile,
    revokeLocalVideoPreview,
    ensureVideoUploaded,
    beginVideoUploadProgress,
    endVideoUploadProgress,
    createVideoUploadProgressHandlers,
} from '../../../utils/ossVideoUpload'
import { resolveMediaUrl, resolvePlayableMediaUrl, applyPlayableMediaUrl, isAliyunOssHttpsUrl } from '../../../utils/mediaUrl'

export default {
    name: 'CampusSceneryManage',
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            BaseApiUrl: BaseApiUrl,
            DepartmentId: 0,
            buttonList: [],
            searchList: [],
            filters: {},
            listLoading: false,
            total: 0,
            page: 1,
            pageSize: 10,
            tableData: [],
            dialogVisible: false,
            dialogTitle: '新增校园风采',
            submitLoading: false,
            form: {
                Id: null,
                DepartmentId: 0,
                DepartmentName: '',
                Title: '',
                Image: '',
                Type: 'image', // 默认图片类型
                SortIndex: 0,
            },
            rules: {
                Title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
                Image: [{ validator: (rule, value, callback) => this.validateCampusImageRule(rule, value, callback), trigger: 'change' }],
                Type: [{ required: true, message: '请选择资源类型', trigger: 'change' }],
            },
            uploadUrl: BaseApiUrl + '/images/Upload/Pic',
            // 预览相关
            previewVisible: false,
            previewUrl: '',
            previewPlaySrc: '',
            previewType: 'image',
            campusVideoPlaySrc: '',
            videoLoading: false,
            pendingVideoFile: null,
            pendingVideoPreviewUrl: '',
            videoUploading: false,
            videoUploadProgress: 0,
        }
    },
    computed: {
        campusVideoPreviewSrc() {
            if (this.pendingVideoPreviewUrl) return this.pendingVideoPreviewUrl
            return this.campusVideoPlaySrc || this.resolveMediaUrl(this.form.Image)
        }
    },
    mounted() {
        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
    },
    methods: {
        resolveMediaUrl,
        /** 图片校验：已保存 URL 或待上传本地预览均算通过；视频同理。最后更新：2026-07-17 */
        validateCampusImageRule(rule, value, callback) {
            const imageVal = (value || '').trim()
            if (this.form.Type === 'video') {
                if (this.pendingVideoFile || imageVal) {
                    callback()
                    return
                }
                callback(new Error('请上传资源'))
                return
            }
            // 延迟上传：选图后 form.Image 仍为空，需认 deferred 本地预览
            if (imageVal || this.deferredImageDisplay('sceneryImage', imageVal)) {
                callback()
                return
            }
            callback(new Error('请上传资源'))
        },
        customCampusVideoUpload(req) {
            const { file, onSuccess, onError } = req
            if (!this.DepartmentId) {
                this.$message.warning('请先选择部门')
                onError(new Error('未选择部门'))
                return
            }
            this.revokePendingVideoLocal()
            const local = attachLocalVideoFile(file)
            this.pendingVideoFile = local.pendingVideoFile
            this.pendingVideoPreviewUrl = local.pendingVideoPreviewUrl
            this.videoLoading = false
            this.$refs.dataForm.validateField('Image')
            onSuccess({ success: true, response: '' })
        },
        revokePendingVideoLocal() {
            revokeLocalVideoPreview(this.pendingVideoPreviewUrl)
            this.pendingVideoFile = null
            this.pendingVideoPreviewUrl = ''
        },
        clearCampusVideoSelection() {
            this.revokePendingVideoLocal()
            this.form.Image = ''
            if (this.$refs.dataForm) {
                this.$refs.dataForm.validateField('Image')
            }
        },
        onCampusDialogClosed() {
            this.revokePendingVideoLocal()
            this.campusVideoPlaySrc = ''
            this.previewPlaySrc = ''
        },
        /** 列表缩略图：OSS 私有地址不直接作 video src，避免无效请求 */
        isOssListVideo(url) {
            return isAliyunOssHttpsUrl(url)
        },
        handleTypeChange(val) {
            this.revokePendingVideoLocal()
            this.deferredImageRevoke('sceneryImage')
            this.campusVideoPlaySrc = ''
            this.form.Image = '';
            if (this.$refs.dataForm) {
                this.$refs.dataForm.clearValidate('Image');
            }
        },
        async refreshCampusVideoPlaySrc() {
            if (this.pendingVideoPreviewUrl || this.form.Type !== 'video') {
                this.campusVideoPlaySrc = ''
                return
            }
            await applyPlayableMediaUrl(this, 'campusVideoPlaySrc', this.form.Image, this.DepartmentId)
        },
        async handlePreviewRecord(url, type) {
            this.previewUrl = url
            this.previewType = type || 'image'
            this.previewPlaySrc = ''
            if (type === 'video' && url) {
                try {
                    this.previewPlaySrc = await resolvePlayableMediaUrl(url, this.DepartmentId)
                } catch (e) {
                    this.$message.error((e && e.message) || '无法播放视频')
                    return
                }
            }
            this.previewVisible = true
        },
        // 工具条按钮回调
        callFunction(item) {
            if (typeof item.search == 'object') {
                this.filters = item.search;
            } else {
                this.filters = { key: item.search };
            }
            this[item.Func].apply(this, item);
        },
        treeNodeClick(data, node, component) {
            this.DepartmentId = data.value;
            this.page = 1;
            this.getList();
        },
        handleQuery() {
            this.page = 1;
            this.getList();
        },
        getList() {
            if (this.DepartmentId == 0) {
                this.$message.warning('请先选择左侧的学校或部门！');
                return;
            }
            this.listLoading = true;
            let para = {
                page: this.page,
                pageSize: this.pageSize,
                departmentId: this.DepartmentId,
                key: this.filters.key || ''
            };
            getCampusSceneryList(para).then(async (res) => {
                if (res.data.success) {
                    this.total = res.data.response.dataCount;
                    const rows = res.data.response.data || [];
                    await this.prefetchListOssMedia(rows, 'Image');
                    this.tableData = rows;
                } else {
                    this.$message.error(res.data.msg);
                }
                this.listLoading = false;
            }).catch(() => {
                this.listLoading = false;
            });
        },
        handleAdd() {
            if (!this.DepartmentId || this.DepartmentId === 0 || this.DepartmentId === '0') {
                this.$message.warning('请先在左侧选择具体的学校机构！');
                return;
            }
            this.revokePendingVideoLocal()
            this.dialogTitle = '新增校园风采';
            this.form = {
                Id: 0,
                DepartmentId: this.DepartmentId,
                DepartmentName: '',
                Title: '',
                Image: '',
                Type: 'image',
                SortIndex: 0,
            };

            this.dialogVisible = true;
            this.deferredImageRevoke('sceneryImage')
            if (this.$refs.dataForm) {
                this.$nextTick(() => {
                    this.$refs.dataForm.clearValidate();
                    if (this.form.Type === 'video') this.refreshCampusVideoPlaySrc()
                });
            }
        },
        handleEdit(row) {
            this.revokePendingVideoLocal()
            this.dialogTitle = '编辑校园风采';
            this.form = Object.assign({}, row);
            this.form.Type = row.Type || 'image';
            this.form.DepartmentId = row.DepartmentId || this.DepartmentId;
            this.deferredImageInit('sceneryImage', this.form.Image)

            this.dialogVisible = true;
            if (this.$refs.dataForm) {
                this.$nextTick(() => {
                    this.$refs.dataForm.clearValidate();
                    if (this.form.Type === 'video') this.refreshCampusVideoPlaySrc()
                });
            }
        },
        handleDelete(row) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeCampusScenery({ id: row.Id }).then(res => {
                    if (res.data.success) {
                        this.$message.success('删除成功!');
                        this.getList();
                    } else {
                        this.$message.error(res.data.msg || '删除失败');
                    }
                });
            }).catch(() => { });
        },
        submitForm() {
            this.$refs.dataForm.validate(async (valid) => {
                if (valid) {
                    if (this.form.Type === 'video') {
                        const hasVideo = this.pendingVideoFile || (this.form.Image || '').trim()
                        if (!hasVideo) {
                            this.$message.warning('请选择视频文件')
                            return
                        }
                    }
                    this.submitLoading = true;
                    if (this.form.Type === 'video' && this.pendingVideoFile) {
                        beginVideoUploadProgress(this)
                        try {
                            const url = await ensureVideoUploaded(
                                this.DepartmentId,
                                this.pendingVideoFile,
                                this.form.Image,
                                'CampusScenery',
                                createVideoUploadProgressHandlers(this)
                            )
                            this.form.Image = url
                            this.revokePendingVideoLocal()
                            await this.refreshCampusVideoPlaySrc()
                        } catch (e) {
                            this.submitLoading = false
                            endVideoUploadProgress(this)
                            this.$message.error((e && e.message) || '视频上传失败')
                            return
                        } finally {
                            endVideoUploadProgress(this)
                        }
                    } else {
                        this.form.Image = await this.deferredImageEnsure('sceneryImage', { foo: 'CampusScenery', currentUrl: this.form.Image })
                    }
                    let pd = Object.assign({}, this.form);
                    if (!pd.DepartmentId) {
                        pd.DepartmentId = this.DepartmentId;
                    }
                    delete pd.DepartmentName;

                    saveCampusScenery(pd).then(res => {
                        this.submitLoading = false;
                        if (res.data.success) {
                            this.$message.success('保存成功!');
                            this.dialogVisible = false;
                            this.getList();
                        } else {
                            this.$message.error(res.data.msg || '保存失败');
                        }
                    }).catch(() => {
                        this.submitLoading = false;
                    });
                }
            });
        },
        beforeUpload(file) {
            const isImg = file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isImg) {
                this.$message.error('上传图片只能是 JPG/PNG 格式!');
            }
            return isImg;
        },
        handleSceneryImageChange(file) {
            if (!file || !file.raw) return
            if (!this.beforeUpload(file.raw)) return
            this.deferredImageChange('sceneryImage', file, { foo: 'CampusScenery', savedUrl: this.form.Image })
            this.$refs.dataForm.validateField('Image');
        },
        clearSceneryImage() {
            this.form.Image = ''
            this.deferredImageRevoke('sceneryImage')
            if (this.$refs.dataForm) this.$refs.dataForm.validateField('Image')
        },
        beforeVideoUpload(file) {
            const isVideo = file.type === 'video/mp4' || file.type === 'video/quicktime';
            this.videoLoading = false
            const isLt100M = file.size / 1024 / 1024 < 100;

            if (!isVideo) {
                this.$message.error('上传视频仅支持 MP4/MOV 格式!');
                return false;
            }
            if (!isLt100M) {
                this.$message.error('上传视频大小不能超过 100MB!');
                return false;
            }
            this.videoLoading = true;
            return true;
        },
    }
}
</script>

<style scoped>
.elegant-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.03);
    display: flex;
    flex-direction: column;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.card-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #1a1f36;
}

.add-btn {
    background: linear-gradient(135deg, var(--btn-primary, #2563eb), #0055ff);
    border: none;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
    border-radius: 8px;
    transition: all 0.3s;
}

.add-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(64, 158, 255, 0.3);
}

/* 缩略图 */
.thumb-img {
    width: 90px;
    height: 60px;
    border-radius: 6px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s;
    cursor: pointer;
}

.thumb-img:hover {
    transform: scale(1.05);
}

/* 操作链接 */
.action-link {
    font-size: 14px;
    margin: 0 6px;
}

.action-link:hover {
    opacity: 0.8;
}

/* 分页 */
.pagination-container {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
}

/* 弹窗样式 */
.dialog-form {
    padding-right: 20px;
}

.dialog-input /deep/ .el-input__inner {
    border-radius: 6px;
}

/* 弹窗上传区域 */
.upload-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.preview-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    opacity: 0;
    transition: opacity 0.3s;
    z-index: 10;
}

.preview-container:hover .preview-mask {
    opacity: 1;
}

.preview-mask i {
    font-size: 24px;
    color: #fff;
    cursor: pointer;
}

.preview-mask i:hover {
    color: var(--btn-primary, #2563eb);
}

.video-uploader /deep/ .el-upload-dragger {
    width: 200px;
    height: 160px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.table-video-oss-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 28px;
    background: #1a1a1a;
}

.table-video-wrapper {
    position: relative;
    width: 90px;
    height: 60px;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
    margin: 0 auto;
    background: #000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.table-thumb-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.table-video-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.4);
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    transition: background 0.3s;
    z-index: 2;
}

.table-video-wrapper:hover .table-video-icon {
    background: rgba(64, 158, 255, 0.8);
}

.single-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 120px;
    background-color: #fafbfc;
    transition: all 0.3s;
}

.single-uploader /deep/ .el-upload:hover {
    border-color: var(--btn-primary, #2563eb);
}

.uploader-icon {
    font-size: 28px;
    color: #8c939d;
}

.preview-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.upload-tip {
    font-size: 12px;
    color: #909399;
}

.save-btn {
    border-radius: 6px;
}
</style>
